<template>
    <div>
        <AppLoading v-if="isLoading" />
        <template v-else-if="error"> {{ error }} </template>
        <v-list v-else-if="paginas?.items">
            <v-list-item v-if="!paginas.items.length">
                <v-list-item-content class="text-center">
                    <v-list-item-title> Nenhum certificado registrado </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
    
            <v-list-item
                v-for="certificado in paginas?.items"
                :key="certificado._id"
            >
                <v-list-item-content>
                    <v-list-item-title class="text-wrap"> {{ obterDescricaoCompletaDoEvento(certificado.evento) }} &dash; {{ formatarData(certificado.evento.data) }}</v-list-item-title>
                    <v-list-item-subtitle :class="`${obterCorDoStatusDoCertificado(certificado)}--text`"> {{ obterDescricaoStatusCertificado(certificado) }} </v-list-item-subtitle>
                </v-list-item-content>
				<v-list-item-action>
					<v-icon
                        tag="a"
                        :disabled="certificado.status !== 'aprovado'"
                        color="primary"
                        :href="certificado.url"
                        target="_blank"
                        class="text-decoration-none"
                    > mdi-download-circle-outline
                    </v-icon>
				</v-list-item-action>
            </v-list-item>
        </v-list>
    </div>
</template>

<script setup lang="ts">
import Irmao from '@/../common/types/Irmao'
import { useQuery } from '@tanstack/vue-query';
import CertificadoService from '@/services/CertificadoService';
import { obterDescricaoCompletaDoEvento } from '@/shareds/sharedsEvento';
import { Certificado, StatusDoCertificado } from 'common/types/certificado/Certificado';
import { formatarData } from '@/../common/shareds/formatadores';
import { obterCorDoStatusDoCertificado } from '@/shareds/sharedCertificado';
import dayjs from 'dayjs';

const { irmao } = defineProps<{ irmao: Irmao }>()

const { data: paginas, error, isLoading } = useQuery({
    queryKey: ['certificados', irmao._id],
    queryFn: () => CertificadoService.findPage({
        idIrmao: irmao._id,
    }),
})

const DESCRICAO_STATUS_EVENTO: Record<StatusDoCertificado, string> = {
    aprovado: 'Aprovado',
    rejeitado: 'Rejeitado',
    solicitado: 'Solicitado'
} as const

function obterDescricaoStatusCertificado(certificado: Certificado) {
    if (certificado.status === 'solicitado') {
        return "Aguardando aprovação"
    }
    return `${DESCRICAO_STATUS_EVENTO[certificado.status]} ${dayjs().to(dayjs(certificado.verificadoEm))}` 
}

</script>